import type { ScoreQueryDTO } from './types'
import { request } from '@/utils'

/**
 * 考试成绩与统计分析接口封装，路径按详细设计文档的 /exam/score 与 /exam/statistics 对接。
 */
export default {
  pageList: (data: ScoreQueryDTO) => request.post('/exam/score/pageList', data),

  overview: (data: Partial<ScoreQueryDTO>) => request.post('/exam/score/overview', data),

  detail: (id: string) => request.get(`/exam/score/${id}/detail`),

  exportExcel: (data: Partial<ScoreQueryDTO>) =>
    request.post('/exam/score/exportExcel', data, {
      responseType: 'blob',
      timeout: 30 * 60 * 1000,
    }),

  statisticsOverview: (taskId: string) => request.get('/exam/statistics/overview', { params: { taskId } }),

  statisticsDept: (taskId: string) => request.get('/exam/statistics/dept', { params: { taskId } }),

  statisticsScoreDistribution: (taskId: string) => request.get('/exam/statistics/scoreDistribution', { params: { taskId } }),

  statisticsRanking: (taskId: string, limit = 10) => request.get('/exam/statistics/ranking', { params: { taskId, limit } }),

  statisticsGradeLevel: (taskId: string) => request.get('/exam/statistics/gradeLevel', { params: { taskId } }),

  statisticsWrongQuestions: (taskId: string) => request.get('/exam/statistics/wrongQuestions', { params: { taskId } }),

  statisticsKnowledge: (taskId: string) => request.get('/exam/statistics/knowledge', { params: { taskId } }),

  statisticsPublication: (taskId: string) => request.get('/exam/statistics/publication', { params: { taskId } }),

  statisticsArchiveList: (taskId: string) => request.get('/exam/statistics/archive', { params: { taskId } }),

  archive: (taskId: string) => request.post('/exam/statistics/archive', { taskId }),

  publishPublication: (id: string) => request.post(`/exam/statistics/publication/${id}/publish`),

  revokePublication: (id: string) => request.post(`/exam/statistics/publication/${id}/revoke`),
}
